/*
 * @Author: monai
 * @Date: 2025-07-16 17:13:58
 * @LastEditors: monai
 * @LastEditTime: 2025-07-23 15:09:45
 */
import {inject} from 'vue';

export default () => {
    const TOOL_countryCode = inject<INJECT_countryCode>('TOOL_countryCode')!;
    const TOOL_RULE = inject<INJECT_rule>('TOOL_RULE')!;
    const TOOL_TEXT = inject<INJECT_text>('TOOL_TEXT')!;
    const TOOL_DOMAIN = inject<DevelopToolShare.ReactDomain>('TOOL_DOMAIN')!;
    const TOOL_activityId = inject<INJECT_activityId>('TOOL_activityId')!;
    const TOOL_activityInfo = inject<INJECT_activityInfo>('TOOL_activityInfo')!;

    return {
        TOOL_countryCode,
        TOOL_RULE,
        TOOL_TEXT,
        TOOL_DOMAIN,
        TOOL_activityId,
        TOOL_activityInfo
    };
};
